//# sourceMappingURL=maintenance_mode.mjs.map
/// <reference types="./maintenance_mode.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $maintenance from "../../../data_types/data/maintenance.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $decrypt from "../../../data_types/decrypt.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $assoc from "../../../tiamat/gleam/assoc.mjs";
import * as $timestamp_ from "../../../tiamat/gleam/time/timestamp_.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, Error, toList } from "../../gleam.mjs";

export function all() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = new $remote.Loading();
          let _pipe$1 = new $msg.ApiReturnedFrozen(_pipe);
          let _pipe$2 = new $msg.MaintenanceMode(_pipe$1);
          dispatch(_pipe$2);
          let _pipe$3 = $ask.to(
            new $ask.Heimdall(),
            toList(["admin", "maintenance"]),
          );
          let _pipe$4 = $ask.via(_pipe$3, new $http.Get());
          let _pipe$5 = $ask.bearing(_pipe$4, access_token);
          let _pipe$6 = $ask.expect(
            _pipe$5,
            (() => {
              let maintenances = $maintenance.assoc_decoder();
              return $decrypt.optional_field(
                "frozen",
                $maintenance.decoder(),
                (frozen) => {
                  return $decode.field(
                    "maintenances",
                    maintenances,
                    (maintenances) => {
                      return $decode.success([frozen, maintenances]);
                    },
                  );
                },
              );
            })(),
          );
          let _pipe$7 = $ask.on_success(
            _pipe$6,
            (maintenances) => {
              let frozen = maintenances[0];
              let maintenances$1 = maintenances[1];
              let _pipe$7 = frozen;
              let _pipe$8 = new $remote.Loaded(_pipe$7);
              let _pipe$9 = new $msg.ApiReturnedFrozen(_pipe$8);
              let _pipe$10 = new $msg.MaintenanceMode(_pipe$9);
              dispatch(_pipe$10);
              let _pipe$11 = maintenances$1;
              let _pipe$12 = new $msg.ApiReturnedMaintenances(_pipe$11);
              let _pipe$13 = new $msg.MaintenanceMode(_pipe$12);
              dispatch(_pipe$13);
              return undefined;
            },
          );
          let _pipe$8 = $ask.on_error(
            _pipe$7,
            (e) => {
              let _pipe$8 = $string.inspect(e);
              let _pipe$9 = new $remote.Errored(_pipe$8);
              let _pipe$10 = new $msg.ApiReturnedFrozen(_pipe$9);
              let _pipe$11 = new $msg.MaintenanceMode(_pipe$10);
              dispatch(_pipe$11);
              return undefined;
            },
          );
          return $ask.run(_pipe$8);
        },
      );
    },
  );
}

export function set(maintenances) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["admin", "maintenance"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(
            _pipe$2,
            $maintenance.encode_assoc(maintenances),
          );
          let _pipe$4 = $ask.expect(_pipe$3, $maintenance.assoc_decoder());
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            (_) => {
              let _pipe$5 = maintenances;
              let _pipe$6 = new $msg.ApiReturnedMaintenances(_pipe$5);
              let _pipe$7 = new $msg.MaintenanceMode(_pipe$6);
              dispatch(_pipe$7);
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function delete$(org_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["admin", "maintenance"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Delete());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(_pipe$2, $json.string(org_id));
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (_) => {
              let _pipe$4 = org_id;
              let _pipe$5 = new $msg.ApiDeletedMaintenance(_pipe$4);
              let _pipe$6 = new $msg.MaintenanceMode(_pipe$5);
              dispatch(_pipe$6);
              return undefined;
            },
          );
          return $ask.run(_pipe$4);
        },
      );
    },
  );
}

export function freeze(starting, ending) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["admin", "maintenance", "freeze"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(
            _pipe$2,
            $json.object(
              toList([
                ["starting", $timestamp_.encode(starting)],
                ["ending", $timestamp_.encode(ending)],
              ]),
            ),
          );
          let _pipe$4 = $ask.expect(
            _pipe$3,
            $decode.then$(
              $decode.string,
              (content) => {
                let $ = content === "ok";
                if ($) {
                  return $decode.success(new Ok(undefined));
                } else {
                  return $decode.failure(new Error(undefined), "Response");
                }
              },
            ),
          );
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            (_) => {
              let frozen = new $maintenance.Complete(starting, ending);
              let _pipe$5 = new Some(frozen);
              let _pipe$6 = new $remote.Loaded(_pipe$5);
              let _pipe$7 = new $msg.ApiReturnedFrozen(_pipe$6);
              let _pipe$8 = new $msg.MaintenanceMode(_pipe$7);
              dispatch(_pipe$8);
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function unfreeze() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["admin", "maintenance", "unfreeze"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Delete());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.on_success(
            _pipe$2,
            (_) => {
              let _pipe$3 = new None();
              let _pipe$4 = new $remote.Loaded(_pipe$3);
              let _pipe$5 = new $msg.ApiReturnedFrozen(_pipe$4);
              let _pipe$6 = new $msg.MaintenanceMode(_pipe$5);
              dispatch(_pipe$6);
              return undefined;
            },
          );
          return $ask.run(_pipe$3);
        },
      );
    },
  );
}
